module.exports = __webpack_public_path__ + "static/Logistics-aba335bebeab8eb872665a0860197cc9.png";